module.exports = __webpack_public_path__ + "static/intertec_screen_1-36446770fbf4793e87e224e40d81b053.avif";